module.exports = __webpack_public_path__ + "static/dog-52f76d5bcba8ff07f80afa0b1d464127.svg";